import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Input, Label, FormGroup

} from 'reactstrap';

import Isvg from "react-inlinesvg";

import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import addIcon from '../../assets/svg/add-icon.svg';
import edit from '../../assets/svg/edit.svg'
import garabage from '../../assets/svg/garbage.svg'

import FormBuilder from '../../components/forms/modalFormBuilder';
import { minValueV2, required } from '../../components/forms/validation';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import ErrorModal from '../../components/errorModal';
import Search from "../../components/search";
import profileUser from "../../assets/images/user.png";
import notification from "../../assets/svg/notification.svg";
import notificationSettings from "../../assets/svg/notifications_settings.svg";
import moreIcon from "../../assets/svg/more.svg";
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';
import Checkbox from '../../components/forms/fields/checkbox';
import { Player, Controls } from "@lottiefiles/react-lottie-player";


import warrning from '../../assets/svg/warrning.svg'

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class AvailabilityTemplates extends Component {
    constructor(props) {
        super(props);
        this.player = React.createRef();
        this.player2 = React.createRef();
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            visitTypes: [],
            total: 0,
            durations: [],
            professions: [],
            defaultColor: '#E0BEEC'
        };
    }


    showPlayer = () => {
        this.setState({
            showPlayer: true,
        });
    };

    hidePlayer = () => {
        this.setState({
            showPlayer: false,
        });
    };

    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, groupId: this.props.selectedGroup })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, groupId: this.props.selectedGroup, clinic: this.props.selectedClinic })).then((data) => {
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    // console.log(dataToSet.page || dataToSet.items || dataToSet.total)
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                this.setState({
                    ...dataToSet,
                    // loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }



    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        let selectedGroupIdx = -1;
        if (this.props.uData) {
            if (this.props.selectedGroup && this.props.uData.clinicGroups) {
                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                    if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                        selectedGroupIdx = i;
                        break;
                    }
                }
            }
        }
        let durations = [];
        for (let i = 5; i <= 90; i += 5) {
            durations.push({ name: i + ' min', value: i });
        }
        this.setState({ durations })

        this.get();
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedGroup != this.props.selectedGroup) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })

        }



        if (prevProps.visitType != this.props.visitType && this.props.visitType?.toString() === '-1') {
            this.props.changeVisitType?.(null);
        }
        if (prevProps.duration != this.props.duration && this.props.duration) {
            let duration = String(this.props.duration)?.replace(/[^0-9]/g, "")?.replace(/^0+/, "");
            let durationNumber = Number(duration);
            if (duration > 0 && duration <= 300) {
                this.props.changeDuration?.(durationNumber);
            } else if (duration > 300) {
                this.props.changeDuration?.(300);
            } else {
                this.props.changeDuration?.('');
            }
        }

    }



    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }


    insertOrUpdate = (data) => {
        const id = data._id ?? 'new';
        let obj = {
            name: data.name,
            description: data.description ?? '',
            visitType: data.visitType,
            professionList: data.professionList ?? [],
            calendarColor: data.calendarColor,
            duration: data.duration,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic
        }
        fetch(API_ENDPOINT + '/data/availability-templates/' + id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {
            if (result.error) {
                this.setState({ error: result.error })
            } else {
                this.get();
                this.props.verifyUser();
                this.setState({
                    form: null,
                })
            }

        })
    }

    /**
    * Delete user
    * @author   Milan Stanojevic
    * @Objectparam    {String} id                   user id
    */
    delete = (data) => {
        this.setState({
            loading: true
        }, () => {

            fetch(API_ENDPOINT + '/data/availability-templates/' + data._id, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }

            }).then(parseJSON).then(({ result, status }) => {
                if (result.error) {
                    this.setState({ error: result.error })
                }
                this.get();
            })
        })

    }

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }

        let selectedGroupIdx = 0;
        if (this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx];
        let fields = [
            { type: 'text', name: 'name', label: 'Name'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'duration', label: 'Duration'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'professions', label: 'Groups'.translate(this.props.lang), allowSort: true, maxWidth: 300 },
            { type: 'text', name: 'visitTypeName', label: 'Connected visit type'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'calendarColor', label: 'Calendar color'.translate(this.props.lang), allowSort: false },
        ];

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <div className="panel">

                                <div className="panel-header">
                                    <h5 className="component-header">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}
                                    </h5>
                                    <button
                                        className="btn add-button"
                                        onClick={() => {
                                            this.setState({
                                                form: {
                                                    calendarColor: this.state.defaultColor,
                                                }
                                            })
                                        }}
                                    >
                                        <Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}
                                    </button>
                                </div>
                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}

                                    fields={fields}
                                    items={this.state.items.map(item => {
                                        return {
                                            ...item,
                                            professions: this.props.lang === 'en' ? item.professionsStringEn : item.professionsStringSv,
                                            duration: item.duration + ' ' + 'min'.translate(this.props.lang),
                                            calendarColor: <div className="calendar-color-list-builder-field" style={{ backgroundColor: item.calendarColor }}></div>
                                        }
                                    })}
                                    actions={
                                        [

                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={edit} /> <div className="chat-icons-tooltip">{'Edit'.translate(this.props.lang)}</div> </div>,
                                                onClick: (item) => {
                                                    let obj = { ...item };
                                                    this.setState({ form: obj })
                                                }

                                            },
                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={garabage} /> <div className="chat-icons-tooltip">{'Delete'.translate(this.props.lang)}</div> </div>,
                                                onClick: (item) => this.setState({ deleteModal: item })
                                            },
                                        ]
                                    }
                                    rawItems={this.state.items}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                                <DeleteModal
                                    lang={this.props.lang}
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal); this.setState({ deleteModal: null }) }}
                                >
                                    {'Delete template'.translate(this.props.lang)} <strong>{this.state.deleteModal && this.state.deleteModal.name}</strong>?
                                </DeleteModal>
                                {this.state.error ?

                                    <ErrorModal lang={this.props.lang}
                                        isOpen={this.state.error}
                                        toggle={() => this.setState({ error: null })}

                                    >
                                        {this.state.error.translate(this.props.lang)}
                                    </ErrorModal>

                                    :
                                    null
                                }




                            </div>
                        </Col>
                    </Row>

                </Container>
                {this.state.form ?
                    <FormBuilder
                        selectedGroup={this.props.selectedGroup}
                        selectedClinic={this.props.selectedClinic}
                        countryTwoLetter={this.props.countryTwoLetter}
                        country={this.props.country}
                        dateFormat={this.props.dateFormat}
                        getStringDateTs={this.props.getStringDateTs}
                        lang={this.props.lang}
                        onSubmit={(data) => {
                            this.insertOrUpdate(data)
                        }
                        }
                        initialValues={this.state.form}
                        size="lg"
                        isOpen={this.state.form}
                        toggle={() => this.setState({ form: null, doctorPermissions: false })}
                        title={this.state.form._id ? 'Edit availability template'.translate(this.props.lang) : 'Add new availability template'.translate(this.props.lang)}
                        buttonText={'Save'.translate(this.props.lang).translate(this.props.lang)}
                        disabledCreatedInfo={true}
                        // additionalButton={
                        //     <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ form: null })} color="primary">{'Cancel'.translate(this.props.lang)}</Button>

                        // }
                        fields={[
                            {
                                type: 'row',
                                children: [
                                    {
                                        type: 'col',
                                        width: {
                                            lg: 6,
                                            sm: 12,
                                            xs: 12
                                        },
                                        children: [
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'name',
                                                        label: 'Name'.translate(this.props.lang),
                                                        validate: [required('Name is required!'.translate(this.props.lang))]

                                                    },
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'textarea',
                                                        name: 'description',
                                                        label: 'Description'.translate(this.props.lang),
                                                    },
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'select',
                                                        name: 'visitType',
                                                        label: 'Connected visit type'.translate(this.props.lang),
                                                        values: [
                                                            { name: 'Select'.translate(this.props.lang), value: -1 },
                                                            ...this.state.visitTypes.map((item, idx) => { return { name: item.name, value: item._id } })
                                                        ],
                                                        validate: [required('Connected visit type is required!'.translate(this.props.lang))]
                                                    }
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'multi-select-modal',
                                                        name: 'professionList',
                                                        // disableFilter: true,
                                                        // selectAllAndDisableValues: this.props.selectAllAndDisableValues ? true : false,
                                                        label: 'Select group(s)'.translate(this.props.lang),
                                                        values: this.state.professions?.map((item, idx) => { return { name: this.props.lang == 'en' ? item.professionEn : item.professionSv, value: item._id } }),
                                                        lang: this.props.lang,
                                                        // validate: [required('You must select at least one group!'.translate(this.props.lang))]
                                                    },
                                                ]
                                            }

                                        ]
                                    },

                                    {
                                        type: 'col',
                                        width: {
                                            lg: 6,
                                            sm: 12,
                                            xs: 12
                                        },
                                        children: [
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'color-picker',
                                                        name: 'calendarColor',
                                                        label: 'Calendar color'.translate(this.props.lang),
                                                        classNameColor: 'availability-templates-calendar-color-picker',
                                                        classNameColorWrap: 'availability-templates-calendar-color-picker-wrap',
                                                        buttonText: 'Choose calendar color'.translate(this.props.lang),
                                                    },
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'duration',
                                                        label: 'Duration'.translate(this.props.lang) + ' (5-300 min)'.translate(this.props.lang),
                                                        // values: [
                                                        //     { name: 'None'.translate(this.props.lang), value: -1 },
                                                        //     ...this.state.durations.map((item, idx) => { return { name: item.name, value: item.value } })
                                                        // ],
                                                        validate: [required('Duration is required!'.translate(this.props.lang)), minValueV2(5, 'Duration must be at least 5 min!'.translate(this.props.lang))]
                                                    }
                                                ]
                                            },

                                        ]
                                    },

                                ]
                            }
                        ]}

                    ></FormBuilder>
                    :
                    null
                }


            </div>
        );
    }
}


const selector = formValueSelector('modalForm');

export default connect(state => {
    return {
        visitType: selector(state, 'visitType'),
        duration: selector(state, 'duration'),
    }
}, {
    changeVisitType: value => change("modalForm", "visitType", value),
    changeDuration: value => change("modalForm", "duration", value)


})(Page(AvailabilityTemplates));